import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/help",
    name: "Help",
    component: () => import(/* webpackChunkName: "help" */ "../views/Help.vue")
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "contact" */ "../views/Contact.vue")
  },
  {
    path: "/categories",
    name: "Categories",
    component: () =>
      import(/* webpackChunkName: "categories" */ "../views/Categories.vue")
  },
  {
    path: "/keywords",
    name: "Keywords",
    component: () =>
      import(/* webpackChunkName: "keywords" */ "../views/Keywords.vue")
  },
  {
    path: "/category/:id",
    name: "Category View",
    component: () =>
      import(
        /* webpackChunkName: "category-view" */ "../views/CategoryView.vue"
      ),
    props: true
  },
  {
    path: "/comparison",
    name: "Comparison Tool",
    component: () =>
      import(
        /* webpackChunkName: "comparison" */ "../views/ComparisonTool.vue"
      ),
    props: route => ({ query: route.query.payload })
  },
  {
    path: "/category/:id/subcategory/:sid",
    name: "Subcategory View",
    component: () =>
      import(
        /* webpackChunkName: "subcategory-view" */ "../views/SubcategoryView.vue"
      ),
    props: true
  },
  {
    path: "/keywordcomparison",
    name: "Keyword Comparison",
    component: () =>
      import(
        /* webpackChunkName: "keyword-comparison" */ "../views/KeywordComparisonTool.vue"
      ),
    props: route => ({ query: route.query.payload })
  },
  {
    path: "/keywordscategory/:id/:sid?",
    name: "Category Keywords",
    component: () =>
      import(
        /* webpackChunkName: "category-keywords" */ "../views/CategoryKeywords.vue"
      ),
    props: true
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
